@let item = task();

<div class="flex align-items-center gap">
    <button
        type="button"
        class="read-toggle"
        [attr.aria-label]="
            (item.isRead
                ? 'layout.backgroundTasks.actions.markUnread'
                : 'layout.backgroundTasks.actions.markRead'
            ) | translate
        "
        (click)="toggleRead($event)"
    >
        <i [class]="'pi ' + (item.isRead ? 'pi-circle' : 'pi-circle-on')"></i>
    </button>

    <div class="flex-column flex-1 gap-small task-content">
        <div class="flex justify-content-between gap-small align-items-start">
            <div class="flex-column gap-x-small">
                <span [class.font-semibold]="!item.isRead">{{
                        item.title | translate: (item.params | backgroundTaskParams)
                    }}</span>
                @if (item.subtitle) {
                    <span class="font-size-small text-color-secondary">{{
                            item.subtitle
                                | translate: (item.params | backgroundTaskParams)
                        }}</span>
                }
            </div>
            <p-tag
                [severity]="taskSeverity[item.status]"
                [icon]="'pi ' + taskIcon(item)"
                [value]="
                    'layout.backgroundTasks.status.' + item.status | translate
                "
            ></p-tag>
        </div>

        @if (item.status === BackgroundTaskStatus.RUNNING ||
        item.status === BackgroundTaskStatus.QUEUED) {
            <div class="flex-column gap-small">
                <p-progress-bar
                    [value]="item.progress"
                    [showValue]="false"
                    [style]="{ height: '4px' }"
                ></p-progress-bar>
                <div
                    class="flex justify-content-between font-size-x-small text-color-secondary"
                >
                    <span>{{
                            item.progressLabel ||
                            'layout.backgroundTasks.status.' + item.status
                                | translate: (item.params | backgroundTaskParams)
                        }}</span>
                    <span>{{ item.progress }}%</span>
                </div>
            </div>
        }

        @if (item.errorMessage) {
            <span class="font-size-small text-danger">{{
                    item.errorMessage
                        | translate: (item.params | backgroundTaskParams)
                }}</span>
        }

        @if (item.status !== BackgroundTaskStatus.QUEUED &&
        item.status !== BackgroundTaskStatus.RUNNING) {
            <div
                class="flex align-items-center justify-content-between gap-small"
            >
                <div
                    class="flex-column gap-x-small font-size-x-small text-color-secondary"
                >
                    <span>{{
                            item.updatedAt | localDate: 'dd.MM.yyyy HH:mm:ss'
                        }}</span>
                    @if (item.status === BackgroundTaskStatus.COMPLETED &&
                    item.resultExpiresAt) {
                        <span>
                            {{ 'layout.backgroundTasks.expiresAt' | translate }}
                            {{
                                item.resultExpiresAt
                                    | localDate: 'dd.MM.yyyy HH:mm'
                            }}
                        </span>
                    }
                </div>

                @if (item.status === BackgroundTaskStatus.COMPLETED &&
                item.resultFileId) {
                    <app-button
                        [label]="actionLabel(item)"
                        [icon]="
                            item.resultType === BackgroundTaskResultType.PRINT
                                ? 'pi-external-link'
                                : 'pi-download'
                        "
                        size="small"
                        [loading]="opening()"
                        (clickEvent)="openResult()"
                    ></app-button>
                }
            </div>
        }
    </div>
</div>
